import ImportHistory from './importHistory.container';

export default ImportHistory;
